<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<mat-card class="content-card">

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex="70">
      <h3>Images</h3>
    </div>
    <div fxFlex="30" class="text-right">

    </div>

  </div>

  <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>

  <br />

  <ng-container *ngIf="!isLoading">

      <div style="display: inline-block; margin: 20px; width: 150px; border-radius: 5px; border: 1px solid grey; padding: 20px; text-align: center; cursor: pointer;" (click)="goToAlbum(albumId)" *ngFor="let albumId of uploadAlbums">
        {{ albumId }}
      </div>




  </ng-container>

</mat-card>
